import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'
import { generateAthosProvider } from 'libs/athos/fetchers/provider'

export class AthosTrending extends AthosFetcher {
  generateURL() {
    return super.generateURL('/trending')
  }

  updateParams() {
    this.params.set('language', 'en')
    this.params.set('limit', 4)

    super.updateParams()
  }
}

export const AthosTrendingProvider = generateAthosProvider(AthosTrending, (results) => {
  return {
    ...results,
    items: results.trending.queries.map((query: any) => ({
      query: query.searchQuery,
      label: query.searchQuery
    }))
  }
})
